/* eslint-disable */
import ButtonCommon from "./Button";
import React from "react";
import { Button, Form } from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";
import { useMemo,useState } from "react";
import VideoPreview from '../../../assets/img/video_preview.webp'
import Icon from "./Icon";

const DonationCampaign = (props) => {
    const { campaignDetails, description } = props;
    const [selectedAmount, setSelectedAmount] = useState(null);

    const getMultipleAmount = useMemo(()=>{
        if(campaignDetails?.details?.contributions_key_type == "multiple"){
            return campaignDetails?.details?.contributions_value_type?.map((item)=>{
                const amount = Number(item / 100);
                const findAmount = campaignDetails?.details?.contributions_value?.find((item1)=>item1?.amount == amount);
                return ({
                    label:`$${amount} ${findAmount?.text?`- ${findAmount?.text}`:""}`, value:amount
                })
            })
        }
        return []
    },[campaignDetails?.details])

    const renderInputField = (placeholder) => {
        return (
          <div className="form-group">
            <input className="form-control2" placeholder={placeholder} />
          </div>
        );
      };
      
    return (
        <section className="donationSection" id="donationSection">
            <div className="container">
                <div className="row">
                    <div className="donationwraps">
                        <h1>Upload Your Face</h1>
                        {description !== "" && (
                            <p className="ql-editor p-0 h-auto" dangerouslySetInnerHTML={{ __html: description, }} ></p>
                        )}
                        <div className="dontionformcreative">
                            <div className="inspiretooForm ">
                                <div className="form-group">
                                    <div className="mb-1" id="uploadSection">
                                        <Form.Check label="Anonymous Contribution" name="anonymous"/>
                                    </div>
                                        <div className="capturebtnwrap button-group-campaign">
                                            <ButtonCommon className="mb-2 background_border d-flex align-items-center justify-content-center " size={"lg"} variant={"success"} disabled={true}>
                                            {/* <Icon icon={VideoPreview} iconSize={20} /> */}
                                                Capture Image
                                            </ButtonCommon>
                                            <label disabled={true} className={`d-flex align-items-center justify-content-center btn Browsebtn w-100 mb-2 disabled`}>
                                            {/* <Image src={VideoPreview} alt="" /> */}
                                                Upload Image
                                            </label>
                                        </div>
                                </div>
                                {renderInputField("First name")}
                                {renderInputField("Last name")}
                                {renderInputField("Email")}
                                {campaignDetails?.details?.contributions_key_type !== "multiple" &&(
                                <div className="form-group">
                                    <label>Amount :</label>
                                    <input className="form-control2" placeholder="Amount"
                                    value={campaignDetails?.details?.contributions_key_type === "fixed" ? Number(campaignDetails?.details?.contributions_value_type) / 100: ""}
                                    disabled={campaignDetails?.details?.contributions_key_type === "fixed"}/>
                                </div>
                                )}
                                {campaignDetails?.details?.contributions_key_type === "multiple" &&(
                                      <div className="">
                                       <label>Select Amount :</label>
                                        {getMultipleAmount?.map((row)=>{
                                            const isSelected = selectedAmount === row.label;
                                            return(<div className="form-group" style={{border: isSelected ? '2px solid #EECA50' : '1px solid white',backgroundColor: isSelected ? '#fff3d4' : '#fff',borderRadius: '4px',}}
                                                // onClick={() => setSelectedAmount(row.label)}
                                                >
                                                <input className="form-control2" value={row?.label} style={{cursor:"pointer", }} placeholder="Amount" />
                                               </div>)})}
                                </div>)}
                                <div className="form-group">
                                <label>Redeem Coupon (optional)</label>
                                <div className="d-flex w-100 gap-2 align-items-start">
                                <input className="form-control2" placeholder="Enter Coupon Code"/>
                                <div className="form-group mb-0 col" role="button" >
                                <ButtonCommon size={"xl"} variant={"process-1"} className={"apply_button"} disabled={true}> APPLY </ButtonCommon>
                                </div>
                                </div>
                                </div>                                
                                <div className="form-group">
                                    <Form.Check
                                        id="remove_ic"
                                        name="terms_and_condition"
                                        label={
                                            <React.Fragment>
                                                I accept terms & conditions{" "} 
                                                <a href={"https://www.facefunding.com/terms-conditions"} target="_blank" className="white-text">View terms of use</a>
                                            </React.Fragment>
                                        }
                                    />
                                </div>
                                <div className="form-group btnformset" >
                                        <Button className="formbtnbig " 
                                        disabled={true} 
                                        >
                                      PAY NOW
                                        </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default DonationCampaign;